import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
// import Swal from "sweetalert2";
import { Link, useParams } from "react-router-dom";

// Material
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import FullscreenIcon from "@mui/icons-material/Fullscreen";

import ImageGraph from "../graphs/ImageGraph";
import DescriptiveStatsResult from "./results/DescriptiveStatsResult";
import GraphicalSummaryResult from "./results/GraphicalSummaryResult";
import TwoSampleTTestResult from "./results/TwoSampleTTestResult";
import OneSampleTTestResult from "./results/OneSampleTTestResult";
import PairedTTestResult from "./results/PairedTTestResult";
import CorrelationResult from "./results/CorrelationResult";
import NormalityTestResult from "./results/NormalityTestResult";
import ANOVAOneWayResult from "./results/ANOVAOneWayResult";
import LoadingResult from "./results/LoadingResult";
import useAnalysesOnSnapshot from "../../hooks/useAnalysesOnSnapshot";
import NPChartResult from "./results/NPChartResult";
import ResponseListResult from "./results/ResponseListResult";

const Analysis = () => {
  const refe = useRef(null);

  const { documentId } = useParams();
  const {
    // documentId: storedDocumentId,
    analysisAndGraphs,
    isLoading,
  } = useSelector((state) => state.dataTable);

  const { analyses } = useAnalysesOnSnapshot(documentId);
  isLoading && refe.current.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  // const RerunTTestComputation = async (selected, selectedIndex) => {
  //   // get the array value of selected column
  //   const value = getColumnValues(data, selected["column"]);

  //   if (value.length > 0) {
  //     //computation using API
  //     const result = await getTTestResults(
  //       value,
  //       confidenceLevel,
  //       hypothesizedMean
  //     );
  //     const boxPlotResult = await getBoxPlot(value);
  //     const histogramResult = await getHistogram(value);

  //     result && dispatch(); // add dispatch here
  //     //update user document
  //     await updateUserDocument(token, uid, email, documentId, {
  //       analysis: tTestResults,
  //     });
  //   }
  // };

  // const ReRunGraph = async (selected, selectedIndex) => {
  //   //get the array value of selected column
  //   const value = getColumnValues(data, selected["column"]);

  //   let graphResult;

  //   if (value.length > 0) {
  //     if (selected["title"] === "Boxplot") {
  //       graphResult = await getBoxPlot(value);
  //     } else {
  //       graphResult = await getHistogram(value);
  //     }

  //     //populate analysis object
  //     const graphs = [
  //       ...analysisGraphs,
  //       {
  //         ...graphResult,
  //         column: selected["column"],
  //         title: selected["title"],
  //         dateTime: currentTimeAndDate(),
  //       },
  //     ];
  //     dispatch(); // add dispatch here
  //     //update user document
  //     await updateUserDocument(token, uid, email, documentId, {
  //       graphs,
  //     });
  //   }
  // };

  const handleMainDisplay = (test) => {
    if (test?.responseList) {
      return <ResponseListResult test={test} />;
    } else {
      if (test.title === "ANOVA (One-way)") {
        // return <h6>{test.title}</h6>;
        return <ANOVAOneWayResult oneway={test} />;
      }
      if (
        test.title === "Correlation" ||
        test.title === "Simple Correlation" ||
        test.title === "Multiple Correlation"
      ) {
        // return <h6>{test.title}</h6>;
        return <CorrelationResult cor={test} />;
      }
      if (test.title === "Descriptive Statistics") {
        // return <h6>{test.title}</h6>;
        return <DescriptiveStatsResult stats={test} />;
      }
      if (test.title === "Graphical Summary") {
        // return <h6>{test.title}</h6>;
        return <GraphicalSummaryResult summary={test} />;
      }
      if (test.title === "Normality Test") {
        // return <h6>{test.title}</h6>;
        return <NormalityTestResult norm={test} />;
      }
      if (test.title === "Paired t") {
        // return <h6>{test.title}</h6>;
        return <PairedTTestResult paired={test} />;
      }
      if (
        test.title === "Multi Variable Boxplot (Ungroup)" ||
        test.title === "Multi Variable Histogram"
      ) {
        return (
          <ImageGraph
            url={
              test.title === "Multi Variable Boxplot (Ungroup)"
                ? test.groupBoxplot
                : test.groupHistogram
            }
            title={test.title}
            column={test.column}
            percent={"GraphOnly"}
            dateTime={test.dateTime}
            analysisId={test.id}
            selectedColors={test.selectedColors}
            isFit={test.isFit}
          />
        );
      }

      if (test.title === "2-Sample t") {
        return <TwoSampleTTestResult result={test} />;
      }

      if (test.title === "1-Sample t") {
        return <OneSampleTTestResult test={test} />;
      }

      if (
        test.title === "Time Series" ||
        test.title === "Simple Boxplot" ||
        test.title === "Simple Histogram" ||
        test.title === "Simple Scatterplot" ||
        test.title === "Pareto Chart" ||
        test.title === "Individual Value Plot"
      ) {
        return (
          <ImageGraph
            url={
              test.title === "Simple Boxplot"
                ? test.boxplot
                : test.title === "Simple Histogram"
                ? test.histogram
                : test.title === "Time Series"
                ? test.timeseries
                : test.title === "Simple Scatterplot"
                ? test.scatterplot
                : test.title === "Individual Value Plot"
                ? test.individualPlot
                : test.percentage
            }
            title={test.title}
            column={test.column}
            percent={"GraphOnly"}
            dateTime={test.dateTime}
            x={test.x}
            y={test.y}
            firstColumn={test.firstColumn}
            secondColumn={test.secondColumn}
            // percetageURL={test.percentage || false}
            analysisId={test.id}
            pearson={test.pearsonr}
            isFit={test?.inputs?.isFit}
            withReg={test.withReg}
            url2={
              test.title === "Simple Histogram"
                ? test.histogramWithDistribution
                : false
            }
          />
        );
      }
    }
  };

  // useEffect(() => {
  // const getTTest = async () => {
  //   console.log("getting test results");
  //   const analysis = await getAnalysis(documentId);
  //   dispatch(setResults(analysis.length ? analysis : []));
  // };

  // const getGraphs = async () => {
  //   console.log("getting graphs");
  //   const graphs = await getAnalysisGraphs(documentId);
  //   dispatch(setAnalysisGraphs(graphs.length ? graphs : []));
  // };
  // getTTest();
  // getGraphs();
  // }, [dispatch, documentId]);

  // useEffect(() => {
  //   console.log("analysisAndGraphs", analysisAndGraphs);
  // }, [analysisAndGraphs]);

  return (
    <>
      <Box sx={{ display: "flex", justifyContent: "space-between" }}>
        <h2
          style={{
            color: "#777777",
          }}
        >
          Analysis
        </h2>

        <Link
          to={`/file/${documentId}/analysis`}
          style={{ display: "flex", gap: "5px", alignItems: "center" }}
          target="_blank"
        >
          <IconButton
            // edge="end"
            aria-label="Open analysis in new tab"
            className="icon_button"
            style={{
              fontSize: "15px",
              float: "right",
              textDecoration: "none",
            }}
          >
            <FullscreenIcon />
            Enlarge
          </IconButton>
        </Link>
      </Box>

      <Container
        style={{
          height: "86%",
          maxHeight: "550px",
          overflow: "scroll",
          overflowX: "hidden",
          marginTop: "10px",
          borderRadius: "10px",
          backgroundColor: "#E8E8E8",
          padding: "20px",
        }}
        ref={refe}
      >
        <LoadingResult isLoading={isLoading} />
        {analyses.map((test, index) => {
          return (
            <Box
              sx={{
                background: "white",
                // gridRow: handleGridRowSpan(test),
              }}
              key={index}
            >
              <Container
                style={{
                  backgroundColor: "white",
                  borderRadius: "7px",
                  padding: "20px",
                  marginBottom: "20px",
                }}
              >
                {handleMainDisplay(test)}
              </Container>
            </Box>
          );
        })}
      </Container>
    </>
  );
};

export default Analysis;
